<template>
    <div>
      <CRUDCriteria :showReset="true" :showSearch="false">
        <template v-slot:criteriaRows>
            <v-row class="mr-6 ml-6 mb-n6">
        <v-col cols='2'>
              <ClarionDateControl
              class="input-text-size"
              v-model="criteriaState.fromDate"
              @blurred="searchByCriteria(), changeTheCriteriaFromDate()"
              v-if="enableDateControl"
              label="From Date"
              :isToggle="false"
              dynamicId="miscMtg-criteria-from-date"
            />
            </v-col>
            <v-col cols='2'>
              <ClarionDateControl
                class="input-text-size"
                v-model="criteriaState.toDate"
                @blurred="searchByCriteria(), changeTheCriteriaToDate()"
                label="To Date"
                v-if="enableDateControl"
                :isToggle="false"
                dynamicId="miscMtg-criteria-to-date"
              />
            </v-col>
            <v-col cols="2" class="mt-4">
              <v-switch
                :label=" isRecordTypeSwitch ? 'Trial' : 'Normal'"
                color="primary"
                v-model="criteriaState.typeOfRecord"
                @change="changeRecordTypeSwitch"
              >
              </v-switch>
            </v-col>
            <v-col cols="2" class="mt-4">
            <v-btn
              :disabled="!isSuperAdmin"
              class="ml-3"
              color="primary"
              small
              dense
              @click="deleteRecords"
            >
              DELETE
            </v-btn>
            </v-col>
      </v-row>
            </template>
      </CRUDCriteria>
    </div>
  </template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import '../../../assets/style.css';
import { authRoles } from '../../../router/roleGroups';
import { isAuthorised } from '../../../store/auth/token';
import { toIsoDate } from '../../../util/shared/tmc-global';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import CRUDCriteria from '../../common/base/crud-2.0/CRUDCriteria.vue';
import { makeCriteriaStateNullIfEmptyString } from '../../tax/common-utils/CommonTaxFunctionalities';

export default {
  data() {
    return {
      isRecordTypeSwitch: false,
      enableDateControl: true,
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  components: {
    ClarionDateControl,
    CRUDCriteria,
  },
  created() {
    this.getCriteria();
  },
  computed: {
    ...mapGetters('base/crud', ['criteria']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    criteriaStateForTaxesApport: {
      get() {
        return this.criteria('taxesApprotionment');
      },
      set(value) {
        this.setCriteria(['taxesApprotionment', value]);
      },
    },
    criteriaStateForApportionment: {
      get() {
        return this.criteria('approtionmentTab');
      },
      set(value) {
        this.setCriteria(['approtionmentTab', value]);
      },
    },
    isSuperAdmin() {
      return isAuthorised(authRoles.SuperAdmin) || isAuthorised(authRoles.UserAdmins);
    },
  },
  watch: {
    'criteriaState.fromBusinessDateValue': {
      handler(newVal) {
        if (newVal || !newVal) {
          this.enableDateControl = false;
          this.criteriaState.fromDate = newVal;
          this.enableDateControl = true;
        }
      },
    },
    'criteriaState.toBusinessDateValue': {
      handler(newVal) {
        if (newVal || !newVal) {
          this.enableDateControl = false;
          this.criteriaState.toDate = newVal;
          this.enableDateControl = true;
        }
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions(['reAuth', 'flashWarn']),
    ...mapActions(['reAuth', 'flashError']),
    ...mapActions('apportionment/apportionmentTab', [
      'deleteRecordFromApportionment',
    ]),
    changeRecordTypeSwitch() {
      this.isRecordTypeSwitch = !this.isRecordTypeSwitch;
      this.$emit('loadCRUDList');
    },
    searchByCriteria() {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      this.$emit('loadCRUDList');
    },
    changeTheCriteriaFromDate() {
      this.criteriaStateForTaxesApport.fromDateValue = this.criteriaState.fromDate;
      this.criteriaStateForApportionment.fromDate = this.criteriaState.fromDate;
    },
    changeTheCriteriaToDate() {
      this.criteriaStateForTaxesApport.toDateValue = this.criteriaState.toDate;
      this.criteriaStateForApportionment.toDate = this.criteriaState.toDate;
    },
    deleteRecords() {
      const { baseCrudKey } = this;
      const collectionName = 'miscMtg';
      if (this.isFiltersAvailable()) {
        if (window.confirm('Are you sure you want to delete these items?')) {
          const initialCriteria = {
            fromDate: this.criteriaState.fromDate
              ? toIsoDate(this.criteriaState.fromDate) : null,
            toDate: this.criteriaState.toDate
              ? toIsoDate(this.criteriaState.toDate) : null,
            typeOfRecord: this.criteriaState.typeOfRecord || false,
            collectionName,
          };
          this.deleteRecordFromApportionment({ baseCrudKey, criteria: initialCriteria });
          this.$emit('loadCRUDList');
        }
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    getCriteria() {
      const res = this.criteria('taxesApprotionment');
      if (res) {
        this.criteriaState.fromDate = res.fromDateValue;
        this.criteriaState.toDate = res.toDateValue;
      }
    },
    isFiltersAvailable() {
      return (this.criteriaState.fromDate && this.criteriaState.toDate);
    },
  },
};
</script>
